import { render, staticRenderFns } from "./productConfigure.vue?vue&type=template&id=4229e50f&scoped=true&"
import script from "./productConfigure.vue?vue&type=script&lang=js&"
export * from "./productConfigure.vue?vue&type=script&lang=js&"
import style0 from "./productConfigure.vue?vue&type=style&index=0&id=4229e50f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4229e50f",
  null
  
)

export default component.exports